/* eslint-disable eqeqeq */
// Статус заданий на установку приложения (progress_orders из getMyInfoEmployer)
// для списков «Активные» и «Выполненные».
//
// progressArray: [установка, отзыв, отзыв в топ, открытие на N-й день],
// 1 — выполнено, 0 — ждёт выполнения, -1 — шага в задании нет.
//
// В новом режиме «кастомных дней открытия» (open_retention_days_list, например 3,8,14)
// сервер не меняет progressArray[3] — он навсегда остаётся 0, а входы пишутся в
// opened_dates / last_open_retention_day. Поэтому такие задания раньше висели
// в «Активных» и после выполнения, и после пропущенных дней. Здесь шаг открытия
// для этого режима считается по расписанию — так же, как ячейки дней на экране
// задания (FifthTaskAndroid): задание активно, пока есть день открытия сегодня
// или впереди, который ещё не засчитан.
import moment from 'moment';

// Дни возврата считаются по московскому времени — так же, как на сервере (performRetention): иначе у
// исполнителя не в Москве день в приложении и на сервере расходится (кнопка активна, а сервер отвечает «не сегодня»)
export const MSK_OFFSET_MINUTES = 180;
export const mskDay = (value) => moment(value).utcOffset(MSK_OFFSET_MINUTES).startOf('day');
const ACTIVE_DAYS_LIMIT = 10;   // как раньше: обычные задания показываем в «Активных» не дольше 10 дней

export const parseRetentionDays = (list) => {
    if (list == undefined || list == null || list === '') {
        return null;
    }
    const days = String(list).split(',')
        .map((day) => parseInt(String(day).trim(), 10))
        .filter((day) => !isNaN(day) && day > 0);
    days.sort((a, b) => a - b);
    return days.length > 0 ? days : null;
};

// Дни открытия: сколько засчитано, сколько пропущено и есть ли ещё что выполнять.
// null — у задания нет кастомных дней открытия (старый режим «на 3-й день» или без него).
export const getRetentionInfo = (task, now) => {
    if (!task) return null;
    const days = parseRetentionDays(task.open_retention_days_list);
    if (!days) return null;
    const installDate = task.install_day || task.order_complete_date_for_reserve_third_day || task.modified;
    if (!installDate) {
        // не знаем, от чего считать дни, — оставляем задание активным, как было
        return { days: days, pending: true, done: 0, missed: 0 };
    }
    const install = mskDay(installDate);
    const since = mskDay(now).diff(install, 'days');
    let openedDays = null;
    if (task.opened_dates && task.opened_dates.length > 0) {
        openedDays = task.opened_dates
            .map((ts) => mskDay(Number(ts)).diff(install, 'days'))
            .filter((day) => !isNaN(day));
    }
    const lastOpenDay = task.last_open_retention_day
        ? mskDay(task.last_open_retention_day).diff(install, 'days')
        : null;
    const isOpened = (day) => (openedDays != null
        ? openedDays.indexOf(day) != -1
        : (lastOpenDay != null && lastOpenDay >= day));
    let done = 0;
    let missed = 0;
    let pending = false;
    days.forEach((day) => {
        if (isOpened(day)) {
            done += 1;
        } else if (since > day) {
            missed += 1;
        } else {
            pending = true;   // день сегодня или ещё впереди
        }
    });
    return { days: days, pending: pending, done: done, missed: missed };
};

// Подробный статус задания на установку.
//   active   — показывать в «Активных»
//   finished — показывать в «Выполненных» (выполнять больше нечего)
//   missed   — сколько дней открытия пропущено (для подписи «Завершено» вместо «Выполнено»)
export const getInstallTaskStatus = (task, now) => {
    const progress = (task && task.progressArray) || [];
    const sdk = task && task.progressArraySDK;
    const sdkPending = !!(sdk && sdk.length > 0 && sdk.indexOf(0) != -1);
    const retention = progress[3] == 0 ? getRetentionInfo(task, now) : null;
    let stepPending = false;
    for (let i = 0; i < progress.length; i++) {
        if (progress[i] != 0) continue;
        if (i == 3 && retention) continue;    // день открытия в новом режиме — по расписанию ниже
        stepPending = true;
    }
    const retentionPending = !!(retention && retention.pending);
    const fresh = task && task.modified
        ? moment(now).diff(moment(task.modified), 'days') < ACTIVE_DAYS_LIMIT
        : true;
    return {
        // Расписание дней ограничено сроком (до 15 дней) — такие задания показываем,
        // пока есть что открывать, даже если последнее действие было больше 10 дней назад.
        active: retentionPending || ((stepPending || sdkPending) && fresh),
        finished: !stepPending && !sdkPending && !retentionPending,
        missed: retention ? retention.missed : 0
    };
};

export const isFreshEnough = (task, now) => !task || !task.modified
    || moment(now).diff(moment(task.modified), 'days') < ACTIVE_DAYS_LIMIT;
